<mat-form-field subscriptSizing="dynamic">
    <mat-label
        *ngIf="label()"
        class="st-text-field-label"
        [class.st-text-field-label--required]="required() && !internalValue()">
        {{ label() }}
    </mat-label>
    <div
        *ngIf="showLinks()"
        st-click-stop-propagation
        class="st-text-field__display"
        [class.st-text-field__display--edit]="inEditMode()"
        [innerHTML]="displayValue() | linky: { stripPrefix: false } | highlight: textToHighlight() : inEditMode() | unsafe: 'html'"></div>
    <input
        #control
        matInput
        [disabled]="disabled()"
        [ngModel]="internalValue()"
        [class.st-text-field__input--edit]="!inEditMode()"
        [placeholder]="label() || placeholder()"
        [required]="required()"
        [maxLength]="maxLength()"
        [type]="type()"
        (change)="onValueChanged()"
        (ngModelChange)="onNgModelChanged($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keyup)="keyPressed($event)" />
    <mat-hint *ngIf="hint()"> {{ hint() }} </mat-hint>
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
